import { UserType } from 'src/types/user.types';

type WithUserType = { user_type?: UserType | null };
type Role = string | null | undefined;

export const isParentRole = (role: Role): boolean => role === UserType.parent;

export const isChildRole = (role: Role): boolean => role === UserType.child;

export const isParentUser = (user: WithUserType | null | undefined): boolean =>
  isParentRole(user?.user_type);

export const isChildUser = <T extends WithUserType>(
  user: T | null | undefined,
): user is T & { user_type: UserType.child } => isChildRole(user?.user_type);
